import React from "react";

import { withReportTime } from "../../../shared/containers/containerReportTime";
import { withReportDateControls } from "../../../shared/containers/containerReportDateControls";

import ContentInnerWrapper from "../../../shared/contentInnerWrapper";
import TimeRangeReport from "./timeRangeReport";
import ReportTimeRangeButtonWrapper from "../../ReportPage/ReportTimeRangeButtonWrapper";
import SnackbarWrapper from "../../../shared/items/static/snackbarWrapper";
import Notification from "../../../shared/items/static/notification";
import ReportTimeRangeList from "./reportTimeRangeList";
import getDates from "../../../shared/services/date.service";

import styles from "./reportInTimeRangeForm.module.scss";
import { withSelectedReports } from "../../../shared/containers/containerSelectedReports";

const getReportDates = (props) => {
  const { reportStartDate, reportStartTime, reportEndDate, reportEndTime } = props;

  let startDate = new Date(reportStartDate);
  let startTime = new Date(reportStartTime);
  startDate.setHours(startTime.getHours());
  startDate.setMinutes(startTime.getMinutes());

  let endDate = new Date(reportEndDate);
  let endTime = new Date(reportEndTime);
  endDate.setHours(endTime.getHours());
  endDate.setMinutes(endTime.getMinutes());
  endDate.setSeconds(59);

  return {
    startDate,
    endDate,
  };
};

const isInvalidTime = (startDate, startTime, endDate, endTime) => {
  if (startDate === null || startTime == null || endDate === null || endTime === null) {
    return true;
  }

  let startHour = startTime.getHours();
  let startMin = startTime.getMinutes();
  let endHour = endTime.getHours();
  let endMin = endTime.getMinutes();

  let rangeStartDate = new Date(startDate);
  rangeStartDate.setHours(startHour);
  rangeStartDate.setMinutes(startMin);

  let rangeEndDate = new Date(endDate);
  rangeEndDate.setHours(endHour);
  rangeEndDate.setMinutes(endMin);

  let startDateUtc = getDates.getNullTimeDateUtcNumber(startDate);
  let endDateUtc = getDates.getNullTimeDateUtcNumber(endDate);

  return /* startDateUtc === endDateUtc &&  */ rangeStartDate >= rangeEndDate;
};

const ReportInTimeRangeForm = (props) => {
  const { onChangeTimeReport, reportStartDate, reportStartTime, reportEndDate, reportEndTime, isReportDateControlsOpen, selectedReports } =
    props;

  const isDayInterval = selectedReports.length > 0 && selectedReports[0].requestInerval === 1;

  if (isDayInterval) {
    reportStartDate.setHours(0);
    reportStartDate.setMinutes(0);
    reportStartDate.setSeconds(0);

    reportStartTime.setHours(0);
    reportStartTime.setMinutes(0);
    reportStartTime.setSeconds(0);

    reportEndDate.setHours(0);
    reportEndDate.setMinutes(0);
    reportEndDate.setSeconds(0);

    reportEndTime.setHours(0);
    reportEndTime.setMinutes(0);
    reportEndTime.setSeconds(0);
  }

  const startDate = getDates.getNullTimeDateUtcNumber(reportStartDate);
  const endDate = getDates.getNullTimeDateUtcNumber(reportEndDate);
  const currentDate = getDates.getNullTimeDateUtcNumber(new Date());

  const isTimeInvalid = isInvalidTime(reportStartDate, reportStartTime, reportEndDate, reportEndTime);

  const isButtonDisabled =
    !reportStartDate ||
    !reportStartTime ||
    !reportEndDate ||
    !reportEndTime ||
    isNaN(reportStartDate) ||
    isNaN(reportStartTime) ||
    isNaN(reportEndDate) ||
    isNaN(reportEndTime) ||
    startDate > currentDate ||
    startDate > endDate ||
    isTimeInvalid;

  return isReportDateControlsOpen ? (
    <ContentInnerWrapper>
      <div className={styles.container_dateTimeWrapper}>
        <div className={styles.container_itemsTimeIntellegence}>
          <TimeRangeReport onHandleChangeStore={onChangeTimeReport} valueStore={props} />
          <div className={styles.container_itemsTimeButtom}>
            {isTimeInvalid ? (
              <Notification type="error">
                <p>{`Конечное время (${getDates.getTimeFormat1(reportEndTime)}) не должно быть раньше начального (${getDates.getTimeFormat1(
                  reportStartTime
                )})`}</p>
              </Notification>
            ) : (
              <ReportTimeRangeButtonWrapper
                startDate={getReportDates(props).startDate}
                endDate={getReportDates(props).endDate}
                disabled={isButtonDisabled}
              />
            )}
          </div>
        </div>
        <div className={styles.container_timeRangeList}>
          <ReportTimeRangeList onHandleChangeStore={onChangeTimeReport} />
        </div>
      </div>
    </ContentInnerWrapper>
  ) : null;
};

export default withReportDateControls(withReportTime(withSelectedReports(React.memo(ReportInTimeRangeForm))));
